import React from 'react';
// formik
import { FieldArray } from 'formik';
//mui
import { Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import SalesForm from './SalesForm';

const SalesBillFormList = ({ formik, ArrayHelperRef }) => {
  //const classes = useStyles();

  return (
    <FieldArray
      name="purchaseBills"
      render={(arrayHelpers) => {
        ArrayHelperRef.current = arrayHelpers;
        return (
          <Box>
            <TableContainer
              size="small"
              //className={classes.table}
              sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
            >
              <Table padding="none">
                <TableHead>
                  <TableRow>
                    <TableCell>No</TableCell>
                    <TableCell align="center">매출일자</TableCell>
                    <TableCell>매출처</TableCell>
                    <TableCell>매출내용</TableCell>
                    <TableCell align="center">해외거래</TableCell>
                    <TableCell align="center">총매출금액</TableCell>
                    <TableCell align="center">기매출금액</TableCell>
                    <TableCell align="center">매출합계</TableCell>
                    <TableCell align="center">매출금액</TableCell>
                    <TableCell align="center">부가세</TableCell>
                    <TableCell align="center">수금예정일자</TableCell>
                    <TableCell align="center">매출횟수</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formik.values?.purchaseBills &&
                    formik.values?.purchaseBills.map((bill, index) => {
                      return (
                        <SalesForm
                          key={index}
                          index={index}
                          bill={bill}
                          formik={formik}
                        />
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );
      }}
    ></FieldArray>
  );
};

export default SalesBillFormList;
